import './App.css';
import './Style.css';
import { useCallback, useEffect, useState } from 'react';
import { supabase } from './sources/client';
import '@suiet/wallet-kit/style.css';
import { ConnectButton, useWallet } from "@suiet/wallet-kit";

const DEFAULT_NAME = process.env.REACT_APP_NFT_NAME;
const DEFAULT_DESCRIPTION = process.env.REACT_APP_NFT_DESC;
const DEFAULT_URL = process.env.REACT_APP_NFT_IMG;

function App() {
  const [msgNotice, setMsgNotice] = useState(null);
  const [loadMint, setLoadMint] = useState(false);
  const [creating, setCreating] = useState(false);
  const {
    connected,
    account,
    executeMoveCall
  } = useWallet();

  const onCreateClick = useCallback(async () => {
    if (account?.address !== null) {
      setLoadMint(true);
      setCreating(true);
      const name = (DEFAULT_NAME).trim();
      const desc = (DEFAULT_DESCRIPTION).trim();
      const url = (DEFAULT_URL).trim();
      try {
        const result = await executeMoveCall({
          packageObjectId: '0x2',
          module: 'devnet_nft',
          function: 'mint',
          typeArguments: [],
          arguments: [name, desc, url],
          gasBudget: 10000,
        });
        const nftID =
          result?.effects?.created?.[0]?.reference
            ?.objectId;
        // eslint-disable-next-line no-console
        setMsgNotice(
          `Congratulation! Mint Success. ${nftID ? `Nft ID: ${nftID}` : ''}`
        );

        var dateNow = new window.Date();
        await supabase
          .from('dataCleolist')
          .insert({ wallet_address: account?.address, nft_id: nftID, created_at: dateNow })
      } catch (e) {
        setMsgNotice('Please check your balance or try again!');
      } finally {
        setCreating(false);
      }
      setLoadMint(false);
    }
  }, [account]);

  useEffect(() => {
  }, [connected]);

  useEffect(() => {
    let timeout;
    if (msgNotice) {
      timeout = setTimeout(() => setMsgNotice(null), 10000);
    }
    return () => clearTimeout(timeout);
  }, [msgNotice]);

  return (
    <div className=''>
      <section className="py-12 sm:py-16 lg:py-20 h-screen">
        {connected ? (
          <>
            <ConnectButton label='Connect' />
            <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl h-full centered-object">
              <div className="max-w-sm mx-auto md:max-w-4xl">
                <div>
                  <p className="text-5xl font-bold text-gray-900 text-center">
                    Cleo Mint
                  </p>
                </div>

                <div className="drop-shadow-xl mt-6 overflow-hidden bg-white border border-gray-200 md:mt-8 rounded-xl">
                  <div className="md:flex">
                    <div className="md:max-w-xs">
                      <img className="object-cover w-full h-full" src="https://bafkreieozzbvsugslx3oe7j4bi5bhkvti2c2g5dqzxuw62g7aktkm7huyi.ipfs.nftstorage.link/" alt="" />
                    </div>

                    <div className="flex flex-col justify-between flex-1 p-6 sm:p-8 self-center">

                      <div className="mt-12 space-y-5 text-center md:mt-0">
                        <div className='font-medium'>Wallet Account:</div>
                        <span className="text-gray-900">{account?.address}</span>
                        {!loadMint ?
                          <>
                            <button type="button"
                              onClick={onCreateClick}
                              disabled={creating}
                              className="inline-flex items-center justify-center w-full px-6 py-4 text-xs font-bold tracking-widest text-white uppercase transition-all duration-200 bg-cleo2-900 border border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 hover:bg-gray-700">
                              Mint
                            </button>
                          </>
                          :
                          <div className="text-center">
                            <div role="status">
                              <svg className="inline mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                              </svg>
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        }


                        {msgNotice ? (
                          <div className="error">
                            <p className="text-sm font-medium text-gray-900">
                              {msgNotice.message ||
                                JSON.stringify(msgNotice, null, 4)}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <ConnectButton label='Connect' />
            <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl h-full centered-object">
              <div className="max-w-sm mx-auto md:max-w-4xl">
                <div>
                  <p className="text-5xl font-bold text-gray-900 text-center">
                    Cleo Mint
                  </p>
                </div>

                <div className="drop-shadow-xl mt-6 overflow-hidden bg-white border border-gray-200 md:mt-8 rounded-xl">
                  <div className="md:flex">
                    <div className="md:max-w-xs">
                      <img className="object-cover w-full h-full" src="https://bafkreieozzbvsugslx3oe7j4bi5bhkvti2c2g5dqzxuw62g7aktkm7huyi.ipfs.nftstorage.link/" alt="" />
                    </div>

                    <div className="flex flex-col justify-between flex-1 p-6 sm:p-8 self-center">

                      <div className="mt-12 space-y-5 text-center md:mt-0">
                        <div className='font-medium'>Wallet Account:</div>
                        <span className="text-gray-900">{account?.address}</span>

                        <button type="button"
                          disabled
                          className="inline-flex items-center justify-center w-full px-6 py-4 text-xs font-bold tracking-widest text-white uppercase transition-all duration-200 bg-gray-900 border border-transparent rounded-lg">
                          Connect Your Wallet First
                        </button>

                        {msgNotice ? (
                          <div className="error">
                            <p className="text-sm font-medium text-gray-400">
                              {msgNotice.message ||
                                JSON.stringify(msgNotice, null, 4)}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </section>
      <div className='wave-set'>
        <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
          <defs>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
          </defs>
          <g className="parallax">
            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>
    </div>
  );
}

export default App;
